import React, { useState, useRef, useEffect } from "react";
import { INFRA_PAGE } from "../../data/constants";
import facility1 from "../../assets/fac.png";
import facility2 from "../../assets/fac1.png";
import facility3 from "../../assets/fac2.png";
import facility4 from "../../assets/fac3.png";
import cs1 from "../../assets/cs1.png";
import cs2 from "../../assets/cs2.png";
import cs3 from "../../assets/cs3.png";
import cs4 from "../../assets/cs4.png";
import cs5 from "../../assets/cs5.png";
import chevronLeft from "../../assets/navigate_next.png";
import chevronRight from "../../assets/navigate_prev.png";

const facilityImages = [facility1, facility2, facility3, facility4];
const facilities = INFRA_PAGE.facility.facilities.map((f, i) => ({
  ...f,
  image: facilityImages[i],
}));
const mobileCerts = [cs1, cs2, cs3, cs4, cs5];

const repeatedCertLogos = [...mobileCerts, ...mobileCerts, ...mobileCerts];

const FacilitySectionMobile = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const certLogos = mobileCerts;
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Scroll to the middle set on mount
    const container = scrollRef.current;
    if (container) {
      const logoWidth = 120 + 24; // image width + gap (adjust if needed)
      container.scrollLeft = logoWidth * certLogos.length;
    }
  }, [certLogos.length]);

  const handleScroll = () => {
    const container = scrollRef.current;
    if (!container) return;
    const logoWidth = 120 + 24; // image width + gap (adjust if needed)
    const totalWidth = logoWidth * certLogos.length;
    if (container.scrollLeft <= 0) {
      // Jump to the middle set from the left
      container.scrollLeft = totalWidth;
    } else if (container.scrollLeft >= totalWidth * 2) {
      // Jump to the middle set from the right
      container.scrollLeft = totalWidth;
    }
  };
  const handlePrev = () => {
    console.log('Prev arrow clicked');
    setActiveIndex((prev) => (prev === 0 ? facilities.length - 1 : prev - 1));
  };
  const handleNext = () => {
    console.log('Next arrow clicked');
    setActiveIndex((prev) => (prev === facilities.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className="bg-white">
      {/* Certifications */}
      <div className="py-12 px-6 md:px-20">
        <p className="font-inter font-semibold text-[20px] leading-[150%] tracking-[-0.005em] bg-gradient-to-t from-[#46C1BF] to-[#46C1BF] bg-clip-text text-transparent mb-4 text-center flex">{INFRA_PAGE.facility.certificationsLabel}</p>
        <div
          className="overflow-x-auto scrollbar-hide w-full no-scrollbar"
          ref={scrollRef}
          onScroll={handleScroll}
        >
          <div className="flex gap-4 w-max items-center py-4">
            {repeatedCertLogos.map((src, i) => (
              <img
                key={i}
                src={src}
                alt="Certification"
                className="w-[90px] max-h-[50px] object-contain flex-shrink-0"
              />
            ))}
          </div>
        </div>
      </div>

      <div className="relative w-screen h-[400px] overflow-hidden">
        {/* Slider Track */}
        <div
          className="flex transition-transform duration-700 ease-in-out h-full"
          style={{
            width: `${facilities.length * 100}vw`,
            transform: `translateX(-${activeIndex * 100}vw)`,
          }}
        >
          {facilities.map((facility, i) => (
            <div
              key={i}
              className="w-screen h-full bg-cover bg-center flex-shrink-0"
              style={{ backgroundImage: `url(${facility.image})` }}
            />
          ))}
        </div>

        {/* Overlay Gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#011621] to-transparent z-10 pointer-events-none" />

        {/* Arrows */}
        <button
          className="absolute left-2 top-1/2 -translate-y-1/2 z-30 w-[50px] h-[50px] flex items-center justify-center text-white md:hidden"
          onClick={handlePrev}
          aria-label="Previous facility"
        >
          <img src={chevronLeft} alt="Previous" className="w-[50px] h-[50px]" />
        </button>
        <button
          className="absolute right-2 top-1/2 -translate-y-1/2 z-30 w-[50px] h-[50px] flex items-center justify-center text-white md:hidden"
          onClick={handleNext}
          aria-label="Next facility"
        >
          <img src={chevronRight} alt="Next" className="w-[50px] h-[50px]" />
        </button>

        {/* Text Content */}
        <div className="absolute inset-0 z-20 flex flex-col justify-between items-center text-white text-center py-16">
          <h2 className="font-utility font-medium text-[30px] leading-[120%] tracking-[-0.01em] mt-0">
            Our facility
          </h2>
          <p className="font-utility text-[18px] font-medium leading-[130%] -mb-[174px]">
            {facilities[activeIndex].label}
          </p>

          {/* Stepper */}
          <div className="flex gap-2 mt-0">
            {facilities.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`h-1 w-[50px] rounded-none transition duration-200 ${
                  activeIndex === i ? "bg-white" : "bg-white/50"
                }`}
                aria-label={`Go to facility ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacilitySectionMobile; 